import React, { useEffect, useRef, useState } from 'react'
import './collections-landing.styles.scss';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import CollectionsList from './collections-list.component';
import CollectionsForm from './collections-form.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { useSelector } from 'react-redux';
import { membershipRestrictions, testMemberRestrictions } from '@/utils/membershipRestrictions';
import { properCase } from '@/utils/properCase';
import UpgradeRequiredModal from '@/components/SHARED/upgrade-required-modal/upgrade-required-modal.component';
import { getCollectionFromDb } from '@/utils/getDataFromDb';
import { completeGameElementData } from '@/components/PREVIEW/previewGameElements';

const CollectionsLandingPage = ({ gameElements, gameData }) => {

    const membership = useSelector(state => state.userData.membership);
    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ showUpgradeModal, setShowUpgradeModal ] = useState(null);
    const [ collectionsFromDb, setCollectionsFromDb ] = useState({});
    const [ collectionsRetrieved, setCollectionsRetrieved ] = useState(false);
    const collectionsRef = useRef();
    const location = useLocation()
    let collectionsListener;
    const navigate = useNavigate();

    useEffect(() => {
        
        return () => {
            if (collectionsListener) collectionsListener();
        }
    }, [])

    useEffect(() => {
        if (!gameData || !membership) return;
        checkMembership();
    }, [membership, gameData]);

    useEffect(() => {
        if (!gameData || collectionsRetrieved) return;
        getGameElementsToManage();
        setCollectionsRetrieved(true);
    }, [gameData])

    function checkMembership() {
        const element = 'collections'
        const res = testMemberRestrictions({'gameData': gameData, 'membership': membership, 'element': element})
        // console.log(res);

        if (res.disabled) {
            let message = ''
            const planRest = membershipRestrictions[membership.membership];
            if (res.disabledReason.includes(element)) {
                message = `While using the ${planRest.title}, you are not able to access ${properCase(element)}.`;
            }
            setShowUpgradeModal(message)
        }
    }

    function getGameElementsToManage() {
        if (location.pathname.includes('/preview/manager')) {
            const previewData = Object.values(completeGameElementData).filter(el => el.type === 'collection');
            collectionsRef.current = {};
            previewData.forEach(collection => {
                collectionsRef.current[collection.id] = collection;
            });
            setCollectionsFromDb(collectionsRef.current);
            return;
        }
        getCollectionFromDb({
            "collection": `games/${gameData.gameId}/gameElements`,
            "query1": {
                "key": "type",
                "condition": "==",
                "value": "collection"
            },
            "callback": callback,
            "handleListener": handleListener
        })
        function callback(data) {
            collectionsRef.current = {
                ...collectionsRef.current,
                ...{[data.id]: data}
            }
            setCollectionsFromDb(collectionsRef.current);
        }
        function handleListener(data) {
            collectionsListener = data;
        }
    }

    return (
        <div className={`collections-landing ${screenSize}`}>
            <div className='g-card collections-card'>
                <BackButton cancel={() => navigate(-1)} />
                <div className="g-space-1"></div>
                <div className='card-title'>
                    <ImageContainer 
                        src='/images/icons/collections.png' 
                        alt='collections icon' 
                        className='head-icon' />
                    Create and Edit Collections
                </div>
                <hr />
                <div className='collections-landing-content'>
                    <Routes>
                        <Route path='' element={
                            <CollectionsList 
                                gameData={gameData}    
                                gameElements={gameElements}
                                collectionsFromDb={collectionsFromDb} />
                        }></Route>
                        <Route path='create' element={
                            <CollectionsForm
                                gameData={gameData}
                                gameElements={gameElements}
                                collectionsFromDb={collectionsFromDb} />
                        }></Route>
                        <Route path='edit/:collectionPath' element={
                            <CollectionsForm
                                gameData={gameData}    
                                gameElements={gameElements}
                                collectionsFromDb={collectionsFromDb} />
                        }></Route>
                        <Route path="*" element={
                            <Navigate replace to="/404" />
                        } />
                    </Routes>
                </div>
            </div>
            <UpgradeRequiredModal
                show={showUpgradeModal}
                cancel={() => setShowUpgradeModal(null)}
                message={showUpgradeModal}
            />
        </div>
    )
}

export default CollectionsLandingPage